<template>
	<div class="flex justify-around flex-wrap">
		<div class="item flex flex-direction align-center" v-for="(item, index) in faces" :key="index" @click="goDetail(item.id, item)">
			<img :src="item.image" alt="" />
			<span>{{ item.name }}</span>
		</div>
		<div class="item" v-for="(i, k) in leftFill(faces.length, 3)" :key="'faces_' + i"></div>
	</div>
</template>

<script>
export default {
	props: {
		faces: [Array]
	},
	data() {
		return {};
	},
	methods: {
		goDetail(id, data = {}) {
			this.$emit('detail', { type: 'face', id: id, data: data });
		}
	}
};
</script>

<style lang="scss" scoped="">
.item {
	width: 2.2rem;
	margin-bottom: 0.2rem;
	img {
		width: 2.2rem;
		height: 2.2rem;
	}
	span {
		font-size: 0.28rem;
		color: #d2d2d2;
	}
}
</style>
